module.exports = __webpack_public_path__ + "static/media/interbank-100px.9f954408.svg";